import { render, staticRenderFns } from "./Songs.vue?vue&type=template&id=edc0a194&"
import script from "./Songs.vue?vue&type=script&lang=js&"
export * from "./Songs.vue?vue&type=script&lang=js&"
import style0 from "./Songs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports